// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3SqLX","outer":"outer--CpWoU","inner":"inner--1jGKk","cover":"cover--3m0nk"};